export interface Size {
  width: number;
  height: number;
}

/** CSS size of a page of the given aspect fitted inside the wrapper, rounded to whole pixels. */
export function calcContainSize(wrapperW: number, wrapperH: number, aspect: number) {
  const containerAspect = wrapperW / wrapperH;

  let fgCssW: number;
  let fgCssH: number;

  if (containerAspect >= aspect) {
    fgCssH = wrapperH;
    fgCssW = Math.round(fgCssH * aspect);
  } else {
    fgCssW = wrapperW;
    fgCssH = Math.round(fgCssW / aspect);
  }

  return { fgCssW, fgCssH };
}

export function resolveDevicePixelRatio(devicePixelRatio: number | undefined): number {
  return devicePixelRatio || 1;
}

/** Backing-store size of a canvas drawn at `cssW × cssH` on a `dpr` screen. */
export function canvasPixelSize(cssW: number, cssH: number, dpr: number): Size {
  return { width: Math.round(cssW * dpr), height: Math.round(cssH * dpr) };
}

/** Scale at which the page covers the whole canvas (the blurred background). */
export function coverScale(canvas: Size, page: Size): number {
  return Math.max(canvas.width / page.width, canvas.height / page.height);
}

/** Scale at which the whole page fits inside the canvas (the foreground). */
export function containScale(canvas: Size, page: Size): number {
  return Math.min(canvas.width / page.width, canvas.height / page.height);
}

/**
 * Offset that centres a viewport on the canvas, both in device pixels: the viewport is scaled
 * from the backing store, so the context draws it untransformed.
 */
export function centerOffset(canvas: Size, viewport: Size): { x: number; y: number } {
  return {
    x: (canvas.width - viewport.width) / 2,
    y: (canvas.height - viewport.height) / 2,
  };
}
